import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useState } from 'react';
import * as styles from "./LocalePanel.styles";
import { Flag } from "../../atoms/Flag/Flag";
import { useSiteChromeDynamicContext } from "../../../context/SiteChromeDynamicContext/useSiteChromeDynamicContext";
import { getCurrency } from "../../../utils/getCurrency";
export var LocalePanel = function LocalePanel(_ref) {
  var buttonStyles = _ref.buttonStyles,
    currencyStyles = _ref.currencyStyles,
    flagStyles = _ref.flagStyles,
    headingStyles = _ref.headingStyles,
    placement = _ref.placement;
  var _useSiteChromeDynamic = useSiteChromeDynamicContext(),
    _useSiteChromeDynamic2 = _slicedToArray(_useSiteChromeDynamic.locale, 1),
    currentLocale = _useSiteChromeDynamic2[0],
    open = _useSiteChromeDynamic.localeModal.open;
  var currency = getCurrency(currentLocale.currency);
  var onClick = useCallback(function () {
    return open(placement);
  }, [open, placement]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClient = _useState2[0],
    setIsClient = _useState2[1];
  useEffect(function () {
    setIsClient(true);
  }, []);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: [styles.copy, styles.heading, headingStyles]
  }, "Shopping in"), isClient && /*#__PURE__*/React.createElement(Flag, {
    countryCode: currentLocale.countryCode,
    countryName: currentLocale.countryName,
    styles: [styles.flag, flagStyles],
    width: 20
  }), isClient && currency && /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css3: [styles.copy, currencyStyles]
  }, currency.symbol, " ", currency.code), /*#__PURE__*/React.createElement(_StyledButton, {
    onClick: onClick,
    type: "button",
    $_css4: [styles.copy, styles.button, buttonStyles]
  }, "Change"));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h4")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledSpan = _styled3("span")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledButton = /*#__PURE__*/_styled4("button").withConfig({
  displayName: "LocalePanel___StyledButton",
  componentId: "sc-1wh867s-0"
})(["", ""], function (p) {
  return p.$_css4;
});